import React from 'react';
import {Chip} from "@mui/material";
import {ProjectJson} from "../../api/json/ProjectJson";
import {AnyColumnJson} from "../../api/json/ColumnJson";
import {resolveNameForColumnType} from "../../api/enum/ColumnType";
import ModalBase from "../modal/ModalBase"
import ColumnForm from "./ColumnForm"

interface ColumnModalProps {
    project: ProjectJson
    column?: AnyColumnJson
    open: boolean
    close: () => void
}

function ColumnModal({project, column, open, close}: ColumnModalProps) {

    return (
        <ModalBase
            open={open}
            setOpen={() => close()}
            title={`${column ? "Edit" : "New"} Column`}
            topRightButton={column && <Chip label={resolveNameForColumnType(column.type)}/>}
            blockBackdropClick
        >
            <ColumnForm
                project={project}
                column={column}
                didCreate={() => close()}
                didSave={finished => { if (finished) close() }}
                didDelete={() => close()}
            />
        </ModalBase>
    );
}

export default ColumnModal;